import * as Preact from "preact"
import * as Ribbit from "@frog/source/utility/integration/Ribbit.js"
import Dev from "@frog/source/models/dev/Dev.js"
import App from "@frog/source/models/App.js"

import "@frog/source/views/dev/SceneReadout.less"

function convertEventsListToPlaintextRibbit(eventsList) {
    let plaintextRibbit = ""

    eventsList.forEach((event) => {
        if(event.type == "javascript") {
            plaintextRibbit += ">> Action " + event.body + "\n"
        } else if(event.type == "comment") {
            plaintextRibbit += "//" + event.body + "\n"
        } else if(event.type == "ribbit") {
            plaintextRibbit += event.body + "\n"
        } else if(event.type == "subscene") {
            plaintextRibbit += event.body + "\n"
        }
    })

    return plaintextRibbit
}

function convertEventsListToHypertextRibbit(eventsList, options) {
    options = options || {}
    let hypertextRibbit = []

    let whitespacePrefix = ""
    if(options.indent != undefined) {
        whitespacePrefix = " ".repeat(options.indent)
    }

    if(eventsList.length == 0) {
        return [(
            <div class="Comment">
                {whitespacePrefix}
                {"// Start your story here"}
            </div>
        )]
    }
    hypertextRibbit = eventsList.map((step) => {
        if(step.type == "javascript") {
            return (
                <div class="Code" title={step.body}>
                    {whitespacePrefix}
                    <span class="Hover">
                        {">> Action "}
                    </span>
                    <span class="Hidden">
                        {step.body}
                    </span>
                </div>
            )
        } else if(step.type == "comment") {
            return (
                <div class="Comment">
                    {whitespacePrefix}
                    {"//" + step.body}
                </div>
            )
        } else if(step.type == "subscene") {
            return (
                <div class="Conditonal" eventKey={step.key}>
                    <div class="Condition">
                        {whitespacePrefix}
                        if {step.condition}:
                    </div>
                    <div class="ConditionalEvents">
                        {convertEventsListToHypertextRibbit(step.eventsList, {"indent": (options.indent || 0) + 4})}
                    </div>
                </div>
            )
        } else if(step.type == "ribbit") {
            const WORD_SEPARATOR = /(\b)/g
            const cueStrings = step.body.split(":")
            let words = step.body.split(WORD_SEPARATOR)
            let lineHypertext = []
            // <span style='color:black'>
            if(cueStrings.length > 1) {
                const cue = cueStrings[0].split(":")[0].toLowerCase()
                const followingWords = cueStrings[1].split(WORD_SEPARATOR)
                if(Ribbit.RIBBIT_COMMANDS[cue] != undefined) {
                    if(Object.keys(Ribbit.RIBBIT_COMMANDS[cue]).length > 0) {
                        return (
                            <div class="Dialog" stepKey={step.key} onClick={onClickTextbox(step.key)}>
                                {whitespacePrefix}
                                <span class="Cue">
                                    {cueStrings[0] + ":"}
                                </span>
                                <span class="Command">
                                    {followingWords[0]}
                                </span>
                                {followingWords.slice(1).map((word) => {
                                    return (
                                        <span class="Parameter">
                                            {word}
                                        </span>
                                    )
                                })}
                            </div>
                        )
                    }
                    return (
                        <div class="Dialog" stepKey={step.key} onClick={onClickTextbox(step.key)}>
                            {whitespacePrefix}
                            <span class="Cue">
                                {cueStrings[0] + ":"}
                            </span>
                            {followingWords.map((word) => {
                                return (
                                    <span class="Parameter">
                                        {word}
                                    </span>
                                )
                            })}
                        </div>
                    )
                }

                let speakerName = cueStrings[0].split(":")[0]
                let maskName = undefined
                if(speakerName.includes(" (")) {
                    maskName = speakerName.split(" (")[0]
                    speakerName = speakerName.split(" (")[1]
                    speakerName = speakerName.slice(0, speakerName.length - 1)
                }
                let returnedClass = "UnknownCue"
                if(Ribbit.mapKeywordToUnitKey(cue.toLowerCase(), Dev.loadedProtostage) != undefined) {
                    returnedClass = "Cue"
                }
                if(maskName != undefined) {
                    lineHypertext.push(
                        <span>
                            <span class="Parameter">
                                {maskName}
                            </span>
                            <span class="Connector">
                                {" ("}
                            </span>
                            <span class={returnedClass}>
                                {speakerName}
                            </span>
                            <span class="Connector">
                                {"):"}
                            </span>
                        </span>
                    )
                } else {
                    lineHypertext.push(
                        <span class={returnedClass}>
                            {cueStrings[0] + ":"}
                        </span>
                    )
                }
                words = cueStrings.slice(1).join(":").split(WORD_SEPARATOR)
            }

            let isInExpressionTag = false
            lineHypertext.push(...words.map((word) => {
                if(word.startsWith("#")) {
                    isInExpressionTag = true
                    return (
                        <span class="ExpressionTag">
                            {word}
                        </span>
                    )
                }
                if(isInExpressionTag == true) {
                    return (
                        <span class="ExpressionValue">
                            {word}
                        </span>
                    )
                }
                return word
            }))

            return (
                <div class="Dialog" stepKey={step.key} onClick={onClickTextbox(step.key)}>
                    {whitespacePrefix}
                    {lineHypertext}
                </div>
            )
        }
    })

    return hypertextRibbit
}
function onClickTextbox(key) {
    return () => {Dev.devSelection.selectedSceneStepKey = key}
}

export default class SceneReadout extends Preact.Component {
    constructor() {
        super()
        this.ref = Preact.createRef()
    }
    render() {
        Dev.wasScriptwriterFocused = document.activeElement.id === "Scriptwriter"
        if(Dev.wasScriptwriterFocused == true) {
            const windowSelection = window.getSelection()
            let node = windowSelection.anchorNode
            let cursorOffsetInLine = windowSelection.anchorOffset
            if(node?.parentNode != undefined) {
                if(node.parentNode.id == "Scriptwriter") {
                    cursorOffsetInLine = 0
                    for(let childIndex = 0; childIndex <= windowSelection.anchorOffset; childIndex++) {
                        cursorOffsetInLine += node.childNodes.item(childIndex).textContent.length
                    }
                } else {
                    while(node.parentNode.id != "Scriptwriter") {
                        let hasReachedCursor = false
                        for(const sibling of node.parentNode.childNodes) {
                            if(sibling == node) {
                                break
                            } else {
                                cursorOffsetInLine += sibling.textContent?.length
                            }
                        }
                        node = node.parentNode
                    }
                }
                const lineNode = node

                let lineOffsetInScene = 0
                let hasReachedCursor = false
                for(let line of lineNode.parentNode.childNodes.values()) {
                    if(line == lineNode) {
                        break
                    } else {
                        lineOffsetInScene += line.textContent.length + 1 // added one for implicit line break
                    }
                }
                Dev.cursorOffsetInScene = lineOffsetInScene + cursorOffsetInLine
            }
        }

        const scene = Dev.devSelection.selectedScene
        const plaintextRibbit = convertEventsListToPlaintextRibbit(scene.events.list)
        const hypertextRibbit = convertEventsListToHypertextRibbit(scene.events.list)
        return (
            <div class="SceneReadout">
                {this.title}
                <div contentEditable="true" id="Scriptwriter"
                    ref={this.ref}
                    key={plaintextRibbit}
                    onInput={this.onInput}
                    onPaste={this.onPaste}
                    onKeyDown={this.onKeyDown()}>
                    {hypertextRibbit}
                </div>
            </div>
        )
    }
    indexNodeListByLetterOffset(nodelist, targetOffset, options) {
        options = options || {}
        const implicitBreakCharacterLength = options.hasImplicitBreakCharacters == true ? 1 : 0

        let currentOffset = 0
        let hasReachedTarget = false
        let result
        nodelist.forEach((node) => {
            if(hasReachedTarget == false) {
                if(currentOffset + node.textContent.length + implicitBreakCharacterLength < targetOffset) {
                    currentOffset += node.textContent.length + implicitBreakCharacterLength
                } else {
                    hasReachedTarget = true
                    const remainder = targetOffset - currentOffset
                    if(node.childNodes?.length > 0) {
                        result = this.indexNodeListByLetterOffset(node.childNodes, remainder)
                    } else {
                        result = {
                            "node": node,
                            "offset": remainder,
                        }
                    }
                }
            }
        })
        return result
    }
    componentDidUpdate() {
        if(this.ref.current == null) return
        if(Dev.wasScriptwriterFocused
        && document.activeElement.id != "Scriptwriter") {
            if(this.ref.current.childNodes != undefined) {
                const newSelection = this.indexNodeListByLetterOffset(this.ref.current.childNodes, Dev.cursorOffsetInScene, {"hasImplicitBreakCharacters": true})
                if(newSelection != undefined) {
                    window.getSelection().setPosition(newSelection.node, newSelection.offset)

                    // If there's a new selection, the previewed selected scene
                    // step needs to be updated too
                    function findStepIncludingNode(node) {
                        if(node != true) return
                        if(node.getAttribute != undefined
                        && node.getAttribute("stepKey") != undefined) return node.getAttribute("stepKey")
                        return findStepIncludingNode(node.parentNode)
                    }
                    Dev.devSelection.selectedSceneStepKey = findStepIncludingNode(newSelection.node)
                } else {
                    const lastWord = getLastChild(this.ref.current)
                    if(lastWord != undefined) {
                        window.getSelection().setPosition(lastWord, lastWord.textContent.length)
                    } else {
                        window.getSelection().setPosition(this.ref.current, 0)
                    }
                }
            } else {
                window.getSelection().setPosition(this.ref.current, 0)
            }
            this.ref.current.focus()
        }
    }
    get onPaste() {
        return (event) => {
            event.preventDefault()
            event.stopPropagation()
            const clipboard = event.clipboardData.getData("text")
            let parsedClipboard
            try {parsedClipboard = JSON.parse(clipboard)} catch {}
            if(parsedClipboard != undefined
            && parsedClipboard.source === "frogTactics") {
                const pastedKey = parsedClipboard.unit.key || parsedClipboard.spot.key

                const cursorNode = this.indexNodeListByLetterOffset(this.ref.current.childNodes, Dev.cursorOffsetInScene, {"hasImplicitBreakCharacters": true}).node
                cursorNode.textContent += pastedKey
                window.getSelection().setPosition(cursorNode, cursorNode.textContent.length)
            }
        }
    }
    get onInput() {
        return (event) => {
            Dev.reloadParsedScriptFromScriptwriter()
        }
    }
    onKeyDown() {
        return (event) => {
            if(event.key == "Tab") {
                const cursorNode = this.indexNodeListByLetterOffset(this.ref.current.childNodes, Dev.cursorOffsetInScene, {"hasImplicitBreakCharacters": true}).node

                let ribbitKeywords = []
                ribbitKeywords.push(...Object.keys(Ribbit.RIBBIT_COMMANDS))
                Object.keys(Ribbit.RIBBIT_COMMANDS).forEach((cue) => {
                    ribbitKeywords.push(cue)
                    if(Object.keys(Ribbit.RIBBIT_COMMANDS[cue]).length > 0) {
                        ribbitKeywords.push(...Object.keys(Ribbit.RIBBIT_COMMANDS[cue]))
                    }
                })
                Object.values(App.game.player.party.units).forEach((partyMember) => {
                    ribbitKeywords.push(partyMember.key)
                    ribbitKeywords.push(partyMember.title)
                    ribbitKeywords.push(partyMember.subtitle)
                    ribbitKeywords.push(partyMember.jobName)
                    if(partyMember.aliases?.length > 0) ribbitKeywords.push(...partyMember.aliases)
                })
                Object.values(App.game.chapter.stage.units).forEach((unit) => {
                    ribbitKeywords.push(unit.key)
                })
                ribbitKeywords = ribbitKeywords.filter((word) => word != undefined)
                ribbitKeywords = ribbitKeywords.map((word) => word.toLowerCase())

            	ribbitKeywords.forEach((keyword) => {
            		if(keyword.includes(cursorNode.textContent.toLowerCase())) {
            			cursorNode.textContent = keyword.toUpperCase()
                        window.getSelection().setPosition(cursorNode, keyword.length)
                    }
            	})
            	event.preventDefault()
            }
            if(event.key == "s"
            && event.metaKey == true) {
                Dev.reloadParsedScriptFromScriptwriter()
                return
            }
            event.stopPropagation()
        }
    }
}
function getLastChild(node) {
    const lastChild = [...node.childNodes.values()].slice(-1)[0]
    if(lastChild?.childNodes?.length > 0) {
        return getLastChild(lastChild)
    } else {
        return lastChild
    }
}
